"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAccountFromSeed = exports.getDerivedSeed = exports.createAssociatedTokenAccount = exports.ASSOCIATED_TOKEN_PROGRAM_ID = exports.findAndCreateAssociatedAccount = exports.signAndSendTransactionInstructions = exports.sleep = exports.Numberu128 = exports.Numberu64 = exports.Numberu32 = exports.Numberu16 = exports.getMidPrice = exports.getMarketData = exports.findAssociatedTokenAddress = void 0;
// @ts-nocheck
const bn_js_1 = __importDefault(require("bn.js"));
const assert_1 = __importDefault(require("assert"));
const tweetnacl_1 = __importDefault(require("tweetnacl"));
const bip32 = __importStar(require("bip32"));
const web3_js_1 = require("@solana/web3.js");
const spl_token_1 = require("@solana/spl-token");
const main_1 = require("./main");
const serum_1 = require("@project-serum/serum");
async function findAssociatedTokenAddress(walletAddress, tokenMintAddress) {
    return (await web3_js_1.PublicKey.findProgramAddress([
        walletAddress.toBuffer(),
        spl_token_1.TOKEN_PROGRAM_ID.toBuffer(),
        tokenMintAddress.toBuffer(),
    ], exports.ASSOCIATED_TOKEN_PROGRAM_ID))[0];
}
exports.findAssociatedTokenAddress = findAssociatedTokenAddress;
async function getMarketData(connection, marketKey) {
    let marketAccountInfo = await connection.getAccountInfo(marketKey);
    if (!marketAccountInfo) {
        throw 'Market account is unavailable';
    }
    let marketData = {
        address: marketKey,
        coinMintKey: new web3_js_1.PublicKey(marketAccountInfo.data.slice(53, 85)),
        coinVaultKey: new web3_js_1.PublicKey(marketAccountInfo.data.slice(117, 149)),
        coinLotSize: new Numberu64(marketAccountInfo.data.slice(349, 357).reverse()),
        pcMintKey: new web3_js_1.PublicKey(marketAccountInfo.data.slice(85, 117)),
        pcVaultKey: new web3_js_1.PublicKey(marketAccountInfo.data.slice(165, 197)),
        pcLotSize: new Numberu64(marketAccountInfo.data.slice(357, 365).reverse()),
        vaultSignerNonce: new Numberu64(marketAccountInfo.data.slice(45, 53).reverse()),
        reqQueueKey: new web3_js_1.PublicKey(marketAccountInfo.data.slice(221, 253)),
        eventQueueKey: new web3_js_1.PublicKey(marketAccountInfo.data.slice(253, 285)),
        bidsKey: new web3_js_1.PublicKey(marketAccountInfo.data.slice(285, 317)),
        asksKey: new web3_js_1.PublicKey(marketAccountInfo.data.slice(317, 349)),
    };
    return marketData;
}
exports.getMarketData = getMarketData;
const getMidPrice = async (connection, marketAddress) => {
    try {
        const market = await serum_1.Market.load(connection, marketAddress, {}, main_1.SERUM_PROGRAM_ID);
        let bids = await market.loadBids(connection);
        let asks = await market.loadAsks(connection);
        return [market, (bids.getL2(1)[0][0] + asks.getL2(1)[0][0]) / 2];
    }
    catch (err) {
        console.log(`Error getting midPrice for ${marketAddress}`);
    }
};
exports.getMidPrice = getMidPrice;
class Numberu16 extends bn_js_1.default {
    /**
     * Convert to Buffer representation
     */
    toBuffer() {
        const a = super.toArray().reverse();
        const b = Buffer.from(a);
        if (b.length === 2) {
            return b;
        }
        assert_1.default(b.length < 2, 'Numberu16 too large');
        const zeroPad = Buffer.alloc(2);
        b.copy(zeroPad);
        return zeroPad;
    }
    /**
     * Construct a Numberu64 from Buffer representation
     */
    static fromBuffer(buffer) {
        assert_1.default(buffer.length === 2, `Invalid buffer length: ${buffer.length}`);
        return new bn_js_1.default([...buffer]
            .reverse()
            .map(i => `00${i.toString(16)}`.slice(-2))
            .join(''), 16);
    }
}
exports.Numberu16 = Numberu16;
class Numberu32 extends bn_js_1.default {
    /**
     * Convert to Buffer representation
     */
    toBuffer() {
        const a = super.toArray().reverse();
        const b = Buffer.from(a);
        if (b.length === 4) {
            return b;
        }
        assert_1.default(b.length < 4, 'Numberu32 too large');
        const zeroPad = Buffer.alloc(4);
        b.copy(zeroPad);
        return zeroPad;
    }
    /**
     * Construct a Numberu32 from Buffer representation
     */
    static fromBuffer(buffer) {
        assert_1.default(buffer.length === 4, `Invalid buffer length: ${buffer.length}`);
        return new bn_js_1.default([...buffer]
            .reverse()
            .map(i => `00${i.toString(16)}`.slice(-2))
            .join(''), 16);
    }
}
exports.Numberu32 = Numberu32;
class Numberu64 extends bn_js_1.default {
    /**
     * Convert to Buffer representation
     */
    toBuffer() {
        const a = super.toArray().reverse();
        const b = Buffer.from(a);
        if (b.length === 8) {
            return b;
        }
        assert_1.default(b.length < 8, 'Numberu64 too large');
        const zeroPad = Buffer.alloc(8);
        b.copy(zeroPad);
        return zeroPad;
    }
    /**
     * Construct a Numberu64 from Buffer representation
     */
    static fromBuffer(buffer) {
        assert_1.default(buffer.length === 8, `Invalid buffer length: ${buffer.length}`);
        return new bn_js_1.default([...buffer]
            .reverse()
            .map(i => `00${i.toString(16)}`.slice(-2))
            .join(''), 16);
    }
}
exports.Numberu64 = Numberu64;
class Numberu128 extends bn_js_1.default {
    /**
     * Convert to Buffer representation
     */
    toBuffer() {
        const a = super.toArray().reverse();
        const b = Buffer.from(a);
        if (b.length === 16) {
            return b;
        }
        assert_1.default(b.length < 16, 'Numberu128 too large');
        const zeroPad = Buffer.alloc(16, 0);
        b.copy(zeroPad);
        return zeroPad;
    }
    /**
     * Construct a Numberu64 from Buffer representation
     */
    static fromBuffer(buffer) {
        assert_1.default(buffer.length === 16, `Invalid buffer length: ${buffer.length}`);
        return new bn_js_1.default([...buffer]
            .reverse()
            .map(i => `00${i.toString(16)}`.slice(-2))
            .join(''), 16);
    }
}
exports.Numberu128 = Numberu128;
const sleep = (ms) => {
    return new Promise(resolve => setTimeout(resolve, ms));
};
exports.sleep = sleep;
// Sign transaction
const signAndSendTransactionInstructions = async (
// sign and send transaction
connection, signers, feePayer, txInstructions) => {
    const tx = new web3_js_1.Transaction();
    tx.feePayer = feePayer.publicKey;
    signers.push(feePayer);
    tx.add(...txInstructions);
    return await connection.sendTransaction(tx, signers, {
        preflightCommitment: 'single',
    });
};
exports.signAndSendTransactionInstructions = signAndSendTransactionInstructions;
const findAndCreateAssociatedAccount = async (systemProgramId, connection, address, mint, payer) => {
    let associated = await findAssociatedTokenAddress(address, mint);
    let associatedInfo = await connection.getAccountInfo(associated);
    if (!Object.is(associatedInfo, null)) {
        return [associated, undefined];
    }
    return [associated, await exports.createAssociatedTokenAccount(systemProgramId, payer, address, mint)];
};
exports.findAndCreateAssociatedAccount = findAndCreateAssociatedAccount;
exports.ASSOCIATED_TOKEN_PROGRAM_ID = new web3_js_1.PublicKey('ATokenGPvbdGVxr1b2hvZbsiqW5xWH25efTNsLJA8knL');
const createAssociatedTokenAccount = async (systemProgramId, fundingAddress, walletAddress, splTokenMintAddress) => {
    const associatedTokenAddress = await findAssociatedTokenAddress(walletAddress, splTokenMintAddress);
    const keys = [
        {
            pubkey: fundingAddress,
            isSigner: true,
            isWritable: true,
        },
        {
            pubkey: associatedTokenAddress,
            isSigner: false,
            isWritable: true,
        },
        {
            pubkey: walletAddress,
            isSigner: false,
            isWritable: false,
        },
        {
            pubkey: splTokenMintAddress,
            isSigner: false,
            isWritable: false,
        },
        {
            pubkey: systemProgramId,
            isSigner: false,
            isWritable: false,
        },
        {
            pubkey: spl_token_1.TOKEN_PROGRAM_ID,
            isSigner: false,
            isWritable: false,
        },
        {
            pubkey: web3_js_1.SYSVAR_RENT_PUBKEY,
            isSigner: false,
            isWritable: false,
        },
    ];
    return new web3_js_1.TransactionInstruction({
        keys,
        programId: exports.ASSOCIATED_TOKEN_PROGRAM_ID,
        data: Buffer.from([]),
    });
};
exports.createAssociatedTokenAccount = createAssociatedTokenAccount;
// For accounts imported from Sollet.io
const getDerivedSeed = (seed) => {
    const derivedSeed = bip32.fromSeed(seed).derivePath(`m/501'/0'/0/0`)
        .privateKey;
    return tweetnacl_1.default.sign.keyPair.fromSeed(derivedSeed).secretKey;
};
exports.getDerivedSeed = getDerivedSeed;
const getAccountFromSeed = (seed) => {
    const derivedSeed = bip32.fromSeed(seed).derivePath(`m/501'/0'/0/0`)
        .privateKey;
    return new web3_js_1.Account(tweetnacl_1.default.sign.keyPair.fromSeed(derivedSeed).secretKey);
};
exports.getAccountFromSeed = getAccountFromSeed;
//# sourceMappingURL=utils.js.map